import { IncrementField } from '@design-system';
import classNames from 'classnames';

import { Image } from '../../Image';
import { ProductPrice } from '../../ProductPrice/ProductPrice';

type Props =
  | {
      disabled: boolean;
      artist: string;
      title: string;
      price?: number;
      quantity: number;
      updateQuantity: (quantity: number) => void;
      allowMultiples: true;
      allowMultiplesLimit: number | null;
      imageUrl: string;
      imageFocus?: string;
    }
  | {
      disabled: boolean;
      artist: string;
      title: string;
      price?: number;
      quantity: number;
      allowMultiples: false;
      imageUrl: string;
      imageFocus?: string;
    };

const ReviewItem = (props: Props) => {
  const {
    allowMultiples,
    artist,
    disabled,
    imageFocus,
    imageUrl,
    price,
    quantity,
    title,
  } = props;
  return (
    <div
      className={classNames('flex w-full flex-col', {
        'text-neutral-4': disabled,
      })}
    >
      <div className="flex w-full items-center justify-center space-x-3">
        <div className="flex flex-1 items-center justify-center space-x-3 overflow-hidden">
          <div className="h-12 w-12 shrink-0">
            <Image
              alt={`${title} by ${artist}`}
              focus={imageFocus}
              shape="rounded"
              src={imageUrl}
              width={48}
            />
          </div>
          <div className="flex flex-1 flex-col overflow-hidden">
            <span className="truncate font-bold">{artist}</span>
            <span className="truncate">{title}</span>
          </div>
        </div>
        {price && (
          <ProductPrice className="shrink-0" price={price * quantity} />
        )}
      </div>
      {allowMultiples && (
        <div className="ml-auto h-max w-max">
          <IncrementField
            disabled={disabled}
            max={props.allowMultiplesLimit || Number.MAX_SAFE_INTEGER}
            onChange={props.updateQuantity}
            value={quantity}
          />
        </div>
      )}
    </div>
  );
};

export { ReviewItem };
